import React, {useEffect} from 'react';
import {EXTERNAL_ENDPOINTS, MAP_ID} from 'Utilities/Constants';

window.loadStorepoint = function(){
    window.storepointWidgetInstance = new window.StorepointWidget(MAP_ID, '#storepoint-widget', {});
    window.dispatchEvent(new Event('storepoint-widget-ready'));
};

function MapContainer(){

    useEffect(() => {
        // Storepoint renders the "Get a Quote" custom button as <a href="#" target="_blank">,
        // which is only meant to fire the widget's 'link-clicked' event (handled elsewhere to
        // open our own modal) but otherwise opens an unwanted blank browser tab. There's no
        // Storepoint API to disable this, so intercept the native click in the capture phase -
        // before the browser's default new-tab action - and block just that placeholder anchor.
        // Real links (directions, website, phone, email) have real hrefs and are left alone.
        const container = document.getElementById('storepoint-widget');
        const blockBlankTab = (e) => {
            const anchor = e.target.closest('a');
            if(anchor && anchor.getAttribute('href') === '#' && anchor.getAttribute('target') === '_blank'){
                e.preventDefault();
            }
        };
        if(container){
            container.addEventListener('click', blockBlankTab, true);
        }

        return function cleanupBlankTabBlocker(){
            if(container){
                container.removeEventListener('click', blockBlankTab, true);
            }
        }
    }, [])

    useEffect(() => {
        let script = document.querySelector(`script[src="${EXTERNAL_ENDPOINTS.STOREPOINT}"]`);
        const scriptCreatedHere = !script;

        if(!script){
            script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = EXTERNAL_ENDPOINTS.STOREPOINT;
            script.onload = function(){
                if(typeof window.loadStorepoint === 'function'){
                    window.loadStorepoint();
                }
            };
            document.head.appendChild(script);
        } else if(typeof window.StorepointWidget === 'function' && !window.storepointWidgetInstance){
            // Script tag already loaded (e.g. a prior mount's cleanup ran after the load event
            // fired), so a fresh <script> tag would never re-fire onload; construct directly.
            window.loadStorepoint();
        }

        return function cleanup(){
            if(scriptCreatedHere){
                document.head.removeChild(script);
            }
            if(window.storepointWidgetInstance && typeof window.storepointWidgetInstance.destroy === 'function'){
                window.storepointWidgetInstance.destroy();
            }
            window.storepointWidgetInstance = null;
        }
    }, [])

    return(
        <div className="map-wrapper">
            <div id="storepoint-widget"></div>
        </div>
    )
}

export default MapContainer;
